import Vue from 'vue'
import Vuex from 'vuex'
import vuexPersistedstate from 'vuex-persistedstate'
Vue.use(Vuex)

// 引入小仓库
import User from './User'
import carManage from './carManage'
import progress from './progress'

const store = new Vuex.Store({
  // 实现Vuex仓库模块式开发数据存储
  modules: {
    // 定义一个模块
    User,
    carManage,
    progress
  },
  plugins: [vuexPersistedstate({
    storage: window.sessionStorage,
  })]
})

export default store